import React from "react";
import { Reveal, Overline } from "./Motion";
import { SmartImage } from "./SmartImage";
import { SIGNATURE } from "@/data/cafe";
import { useDialogs } from "./DialogProvider";
import { Plus } from "lucide-react";

export default function Signature() {
  const { addToCart } = useDialogs();
  return (
    <section id="signature" className="bg-[#F5F2EB] py-24 md:py-32" data-testid="signature-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <Overline>Signature Drinks</Overline>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#1A1514] mt-4 font-medium">
              The ones we're <span className="italic text-[#1C7C54]">famous for</span>
            </h2>
          </div>
          <p className="font-body text-[#1A1514]/60 max-w-sm">Handcrafted house specials — poured with a little extra love.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
          {SIGNATURE.map((d, i) => (
            <Reveal key={d.name} delay={(i % 4) * 0.08}>
              <div className="group" data-testid={`signature-${i}`}>
                <div className="relative overflow-hidden rounded-sm aspect-[3/4] bg-[#E5DFD3]">
                  <SmartImage src={d.image} alt={d.name} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1A1514]/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  <button onClick={() => addToCart({ name: d.name, price: d.price })} data-testid={`signature-add-${i}`}
                    aria-label={`Add ${d.name} to cart`}
                    className="absolute bottom-4 right-4 h-11 w-11 grid place-items-center rounded-full bg-[#1C7C54] text-[#F5F2EB] translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-400 hover:bg-[#14603F]">
                    <Plus className="h-5 w-5" />
                  </button>
                </div>
                <div className="flex items-baseline justify-between mt-4">
                  <h3 className="font-display text-2xl text-[#1A1514]">{d.name}</h3>
                  <span className="font-accent text-[#1C7C54]">₹{d.price}</span>
                </div>
                <p className="font-body text-sm text-[#1A1514]/55 mt-1">{d.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
